/* Pivot des saisies de l'année : une catégorie par ligne du fichier (absences, projets, autre),
   avec les heures par jour, par mois et sur l'année. */
export const ABSENCE_ORDER = [
  ['vacances', 'Congé payé'],
  ['maladie', 'Maladie'],
  ['cours', 'Cours'],
  ['temps_partiel', 'Temps partiel'],
  ['conge_exceptionnel', 'Congé exceptionnel'],
  ['sans_solde', 'Sans solde'],
];
const OTHER_LABEL = 'Autre (réunions, MEP…)';

// Identifiant spécial de brique : __abs_<type>__, __proj_<id>__ (ancien format, saisie « niveau
// projet (général) » sans brique précise), __phase_<id>__ (format actuel, « niveau phase (général) »).
const prefixe = (id, p) => typeof id === 'string' && id.startsWith(p);
const idInEntry = (id, p) => id.replace(new RegExp(`^${p}`), '').replace(/__$/, '');

// Projet (nom + ordre d'affichage) de chaque brique, projet et phase.
function indexProjects(projets) {
  const byBrick = new Map();
  const byProject = new Map();
  const parPhase = new Map();
  projets.forEach((proj, idx) => {
    const p = { nom: proj.nom, order: idx };
    proj.briques.forEach((b) => byBrick.set(b.id, p));
    if (proj.id) byProject.set(proj.id, p);
    (proj.phaseIds || []).forEach((phId) => parPhase.set(phId, p));
  });
  return { byBrick, byProject, parPhase };
}

export function buildCategories({ year, timesheets, projets }) {
  const { byBrick, byProject, parPhase } = indexProjects(projets);
  const cats = new Map();
  function ensureCat(key, label, kind, order) {
    if (!cats.has(key))
      cats.set(key, { label, kind, order, byIso: new Map(), total: 0, monthly: Array(12).fill(0) });
    return cats.get(key);
  }
  const projectOrOther = (proj) =>
    proj
      ? ensureCat('proj_' + proj.nom, proj.nom, 'project', proj.order)
      : ensureCat('autre', OTHER_LABEL, 'autre', 9999);
  // Absences : toujours les 5 lignes (même à 0), comme le modèle
  ABSENCE_ORDER.forEach(([id, label], i) => ensureCat('abs_' + id, label, 'absence', i));

  for (const t of timesheets) {
    const h = parseFloat(t.heures || 0);
    if (!h || !t.date || t.date.slice(0, 4) !== String(year)) continue;
    const id = t.brique_id;
    let cat;
    if (prefixe(id, '__abs_')) {
      const ty = idInEntry(id, '__abs_');
      const label = (ABSENCE_ORDER.find((a) => a[0] === ty) || [, 'Absence'])[1];
      cat = ensureCat(
        'abs_' + ty,
        label,
        'absence',
        ABSENCE_ORDER.findIndex((a) => a[0] === ty),
      );
    } else if (id === '__general__') cat = ensureCat('autre', OTHER_LABEL, 'autre', 9999);
    else if (prefixe(id, '__proj_')) cat = projectOrOther(byProject.get(idInEntry(id, '__proj_')));
    else if (prefixe(id, '__phase_')) cat = projectOrOther(parPhase.get(idInEntry(id, '__phase_')));
    else cat = projectOrOther(byBrick.get(id));
    const month = parseInt(t.date.slice(5, 7), 10) - 1;
    cat.byIso.set(t.date, (cat.byIso.get(t.date) || 0) + h);
    cat.total += h;
    cat.monthly[month] += h;
  }

  return {
    cats,
    absRows: ABSENCE_ORDER.map(([id]) => cats.get('abs_' + id)),
    projectRows: [...cats.values()]
      .filter((c) => c.kind === 'project')
      .sort((a, b) => a.order - b.order || a.label.localeCompare(b.label)),
    autreRow: cats.get('autre'),
  };
}
